/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Component, Inject, ViewChild, ElementRef, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { PageService } from "@auth/services/page";
import { MAT_DIALOG_DATA } from "@angular/material";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { Subscription } from "rxjs";

@Component({
  selector: "assc-lapsed-policies-dialog",
  templateUrl: "./lapsed-policies-dialog.component.html",
  styleUrls: ["./lapsed-policies-dialog.component.scss"],
})
export class AsscLapsedPoliciesDialogComponent implements OnDestroy, OnInit {
  @ViewChild("submissionsDatatable", { static: false }) submissionsDatatable: DatatableComponent;

  private resizeSub: Subscription;
  policies = [];

  dataLoaded = false;

  messages = {
    emptyMessage: "No Lapsed Policies Records to display.",
    totalMessage: "Lapsed Policies Records",
  };
  expanded: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) private injected_data: any, 
    private pageService: PageService,
    public dialogRef: MatDialogRef<AsscLapsedPoliciesDialogComponent>) {
      this.resizeSub = this.pageService.windowResize.subscribe(() => setTimeout(() => this.submissionsDatatable && this.submissionsDatatable.recalculate()));
      this.policies = Object.values(injected_data.policies);
      console.log(this.policies);
    }

  ngOnDestroy() {
    if (this.resizeSub) this.resizeSub.unsubscribe();
  }

  ngOnInit() {
    setTimeout(() => this.dataLoaded = true, 500);
  }

  getDatatableHeight(data, rowHeight) {
    let max_height = 10 * rowHeight;
    let temp_height = (data.length || 1) * rowHeight;
    return temp_height > max_height ? max_height : temp_height;
  }

  toggleExpandRow(row) {
    this.submissionsDatatable.rowDetail.toggleExpandRow(row);
  }

  getDetailHeight(row: any, index: number): number {
    return 160;
  }

  rowClass = (row) => {
    return {
      "bg-light": row.plan_type === 'O',
    };
  };
}
